export let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

let ticking = false;
const scrollFunctions = [];

function animate() {
    scrollFunctions.forEach(funcRef => funcRef());

    ticking = false;
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(animate);
        ticking = true;
    }
}

function scrollHandler() {
    scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    requestTick();
}

export function onScroll(handler, triggerNow = false) {
    !scrollFunctions.length ? initScroll() : null;
    triggerNow ? handler() : null;
    scrollFunctions.push(handler);
}

export function initScroll() {
    window.addEventListener('scroll', scrollHandler);
}
